import React from "react";
import KnowledgeCopyright from "./KnowledgeCopyright";
import KnowledgeCopyrightService from "../../../../../../services/KnowledgeCopyrightService";
import TableComponentWithDialog from "../../../../page/TableComponentWithDialog";
import { labels } from "../../../../../../localization/labels";
import {
  knowledgeValidationRules as validationRules,
  validateEntity
} from "../../../../../../validators/validationRules";
import TableUtils from "../../../../../core/Table/TableUtils";
import { withRouter } from "react-router-dom";
import { withKeycloak } from "@react-keycloak/web";

class KnowledgeCopyrightContainer extends TableComponentWithDialog {
  constructor(props) {
    super(props);

    this.props = props;
    this.knowledgeCopyrightService = new KnowledgeCopyrightService(
      this.keycloak
    );
  }

  resetEntity = () => {
    return {
      name: null,
      description: null
    };
  };

  getComponentTitle = () => {
    return undefined;
  };

  loadData = pageInfo => {
    this.prepareCall(
      this.knowledgeCopyrightService.getEntities(
        pageInfo,
        this.sortInfo,
        this.onDataLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onCreateData = copyright => {
    this.prepareCall(
      this.knowledgeCopyrightService.postEntity(
        copyright,
        this.onDataSaveResponse,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  updateData = copyright => {
    this.prepareCall(
      this.knowledgeCopyrightService.putEntity(
        copyright,
        this.onDataSaveResponse,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onDeleteData = copyright => {
    this.prepareCall(
      this.knowledgeCopyrightService.deleteEntity(
        copyright,
        this.onDataDeleteResponse,
        this.onDeleteSuccessMessage,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  selectRow = {
    ...this.selectRow
  };

  columns = this.initColumns([
    {
      dataField: "id",
      text: labels.id,
      sort: true,
      classes: "column-id",
      headerClasses: "column-header-id"
    },
    {
      dataField: "name",
      text: labels.name,
      sort: true,
      headerClasses: "column-header",
      formatter: TableUtils.textFormatter
    },
    {
      dataField: "description",
      text: labels.description,
      sort: true,
      headerClasses: "column-header",
      formatter: TableUtils.textFormatter
    }
  ]);

  handleReset = () => {
    this.setState({
      newEntity: {
        name: null,
        description: null
      },
      disabled: true
    });
  };

  validator = entity => {
    return validateEntity(entity, validationRules.generalData);
  };

  loadSelectedData = url => {
    this.prepareCall(
      this.knowledgeCopyrightService.getEntitiesByUrl(
        url,
        this.onSelectedEntityLoad,
        this.messageHandler.handleError
      )
    );
  };

  render() {
    const maxLength = {
      name: 255,
      description: 2000
    };
    return (
      <KnowledgeCopyright
        {...this.renderProps()}
        maxLength={maxLength}
        disabled={this.state.disabled}
        validationRules={validationRules.generalData}
      />
    );
  }
}

export default withKeycloak(withRouter(KnowledgeCopyrightContainer));
